export default __webpack_public_path__ + "static/media/logo.a6eb49e3.png";